<script setup>
import { computed } from 'vue';
import { dynamicTime } from 'shared/helpers/timeHelper';

const props = defineProps({
  health: { type: String, default: 'ok' },
  lastExecutionAt: { type: Number, default: null },
});

// Só 'stalled' e 'never_ran' chamam atenção: são os dois estados em que o
// usuário acha que está automatizado e não está.
const TONE = {
  ok: 'bg-n-teal-3 text-n-teal-11',
  stalled: 'bg-n-ruby-3 text-n-ruby-11',
  never_ran: 'bg-n-amber-3 text-n-amber-11',
  draft: 'bg-n-alpha-2 text-n-slate-11',
  inactive: 'bg-n-alpha-2 text-n-slate-11',
};

const HINTS = {
  stalled: 'FLOW_AUTOMATIONS.INDEX.HEALTH.STALLED_HINT',
  never_ran: 'FLOW_AUTOMATIONS.INDEX.HEALTH.NEVER_RAN_HINT',
  draft: 'FLOW_AUTOMATIONS.INDEX.HEALTH.DRAFT_HINT',
};

const toneClass = computed(() => TONE[props.health] ?? TONE.ok);
const hintKey = computed(() => HINTS[props.health] ?? null);
const needsAttention = computed(() =>
  ['stalled', 'never_ran'].includes(props.health)
);
const lastRunLabel = computed(() =>
  props.lastExecutionAt ? dynamicTime(props.lastExecutionAt) : null
);
</script>

<template>
  <span class="inline-flex items-center gap-1.5">
    <span
      class="inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium whitespace-nowrap"
      :class="toneClass"
      :title="hintKey ? $t(hintKey) : undefined"
    >
      <span v-if="needsAttention" aria-hidden="true" class="mr-1">{{
        '⚠'
      }}</span>
      {{ $t(`FLOW_AUTOMATIONS.INDEX.HEALTH.${health}`) }}
    </span>
    <span class="text-xs text-n-slate-11 whitespace-nowrap">
      {{
        lastRunLabel
          ? $t('FLOW_AUTOMATIONS.INDEX.HEALTH.LAST_RUN', { time: lastRunLabel })
          : $t('FLOW_AUTOMATIONS.INDEX.HEALTH.NEVER')
      }}
    </span>
  </span>
</template>
